import { useStore } from "../store";
import { updateInfo } from "../info";
import { SettingContainer } from "./SettingContainer";
import { SettingTitle } from "./SettingTitle";
import { SettingText } from "./SettingText";
import { InputContainer } from "./InputContainer";
import { TextInput } from "./TextInput";
import { NumberInput } from "./NumberInput";
import { DateTimeInput } from "./DateTimeInput";

export function AnimeBroadcastSettings(props) {
  const { anime } = useStore();

  function onBroadcasterSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/broadcaster`, { value }, "방송사", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onReleaseTimeSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/releaseTime`, { value }, "출시일", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onBroadcastDurationSave(e, value, setDisabled) {
    updateInfo(`/anime/${anime.id}/broadcastDuration`, { value }, "방송 길이", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  return (<>
    <SettingTitle text="방송 정보"/>

    <SettingContainer>
      <SettingText text="방송사"/>
      <InputContainer>
        <TextInput id="broadcaster" defaultValue={ props.anime.broadcaster } onClick={ onBroadcasterSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="출시일 (KST)"/>
      <InputContainer>
        <DateTimeInput id="release-time" defaultTime={ props.anime.releaseTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET) } onClick={ onReleaseTimeSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="방송 길이"/>
      <InputContainer>
        <NumberInput id="broadcast-duration" unit="분" defaultValue={ props.anime.broadcastDuration / 60000 } onClick={ onBroadcastDurationSave }/>
      </InputContainer>
    </SettingContainer>
  </>);
}
